import { render, staticRenderFns } from "./luckydraw.vue?vue&type=template&id=35adbde3&scoped=true&"
import script from "./luckydraw.vue?vue&type=script&lang=js&"
export * from "./luckydraw.vue?vue&type=script&lang=js&"
import style0 from "./luckydraw.vue?vue&type=style&index=0&id=35adbde3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35adbde3",
  null
  
)

export default component.exports